/**
 * Created by Filip de Tillier on 05.12.2018.
 */
import Vue from 'vue';

/**
 * @module Store/userData
 * @description Store for user data
 */

/**
 * @constant State of user data
 * @type {object}
* */

const state = {
    userShopsIds : [],
    userShopsById: []
};

/**
 * @constant Getters
 * @type {object}
* */

const getters = {
    getUserShopsIds: state => state.userShopsIds,
    getUserShopsById: state => state.userShopsById
};

/**
 * @constant Mutations
 * @type {object}
* */

const mutations = {
    addUserShopsIds: (state, userShopsIds) => state.userShopsIds = userShopsIds,
    addUserShopsByIds: (state, shops) => {
        let shopsById = [];
        shops.map(el => shopsById[el.id] = el);
        state.userShopsById = shops;
    }
};

/**
 * @constant Actions
 * @type {object}
**/

const actions = {
    async GetUserShopsIds ({ store, commit }, { id }) {
        await Vue.axios.get(`/auth/user/${id}/shop`).then(response => {
            commit('addUserShopsIds', response.data);
        }).catch(err => {
            console.log(err);
        });
    },
    async GetUserShopsByIds ({ commit }) {
        await Vue.axios.get('/stores/store').then(response => {
            commit('addUserShopsByIds', response.data);
        }).catch(err => {
            console.log(err);
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
